/* @flow */
import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';

//----------------------------------------------------------------------//
// CSS                                                                  //
//----------------------------------------------------------------------//

import styles from 'common-scss/formstyles.module.scss';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

//TogglePassword.js
@observer
export default class TogglePassword extends React.Component<*> {
  @observable passwordVisible: boolean;

  toggle() {
    this.passwordVisible = !this.passwordVisible;
  }

  render(): React.Element<*> {
    return (
      <FormControl required={this.props.required} margin="normal">
        <InputLabel error={this.props.error}>{this.props.floatingLabelText}</InputLabel>
        <Input
          type={this.passwordVisible ? '' : 'password'}
          onChange={(e: SyntheticInputEvent<*>) => {
            this.props.model[this.props.prop] = e.target.value;
          }}
          name="password"
          placeholder={this.props.hintText}
          error={this.props.error}
          value={this.props.model[this.props.prop]}
          autoComplete="on"
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="Toggle password visibility"
                onClick={this.toggle.bind(this)}
                color={this.passwordVisible ? 'primary' : 'default'}
              >
                <svg
                  className={`${styles['icon-password']}
                                     ${this.passwordVisible ? styles.visible : ''}`}
                >
                  <use
                    xlinkHref={
                      this.passwordVisible ? '#icon-password-visible' : '#icon-password-hidden'
                    }
                  />
                </svg>
              </IconButton>
            </InputAdornment>
          }
        />
      </FormControl>
    );
  }
}
